import { render, staticRenderFns } from "./OneTimeCodeSignIn.vue?vue&type=template&id=0c6c2677&scoped=true"
import script from "./OneTimeCodeSignIn.vue?vue&type=script&lang=js"
export * from "./OneTimeCodeSignIn.vue?vue&type=script&lang=js"
import style0 from "./OneTimeCodeSignIn.vue?vue&type=style&index=0&id=0c6c2677&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6c2677",
  null
  
)

export default component.exports